import React, { useState } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../assets/css/form.css";
import VerifyOtp from "./otp";
import { BASE_URL } from "../config";

function FormOne() {
  const formikRef = React.useRef(null);
  const fileInput1Ref = React.useRef(null);
  const fileInput2Ref = React.useRef(null);

  const [loading1, setLoading1] = useState(false);
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [photoPreview, setphotoPreview] = useState(null);
  const [showOtpPopup, setShowVerifyOtp] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [newMobileNumber, setNewMobileNumber] = useState("");
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [isBtnDisabled, setBtnDisabled] = useState(false);

  // State to hold signature URL

  const validationSchema = Yup.object({
    // consumerNumber: Yup.string().default(null, ''),
    nameOfConsumer: Yup.string().required("Consumer Name is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    // middleName: Yup.string().default(null, ''),
    dateOfBirth: Yup.date().required("Date of Birth is required"),
    // nameOfSpouse: Yup.string().required("Spouse Name is required"),
    address: Yup.string().required("Address is required"),

    roadName: Yup.string().required("Road Name is required"),
    landMark: Yup.string().required("Landmark is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string().required("Postal Code is required"),
    // rationCardNumber: Yup.string().default(null, ''),
    // telephoneNumber: Yup.string().default(null, ''),
    mobileNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid mobile number")
      .required("Mobile number is required"),
    // panNumber: Yup.string().default(null, ''),
    // passportNumber: Yup.string().default(null, ''),
    // drivingLicenseNumber: Yup.string().default(null, ''),
    aadhaar: Yup.string().required("Aadhaar Number is required"),
    // votersIdNumber: Yup.string().default(null, ''),
    photo: Yup.mixed()
      .required("Profile Image is required")
      .test(
        "fileSize",
        "File size is too large",
        (value) => value && value.size <= 5000000
      ) // 5MB max
      .test(
        "fileType",
        "Unsupported file format",
        (value) => value && ["image/jpeg", "image/png"].includes(value.type)
      ), // Allow JPEG/PNG
    // signatureOfCustomer: Yup.mixed()
    //   .test(
    //     "fileSize",
    //     "File size is too large",
    //     (value) => value && value.size <= 5000000
    //   ) // 5MB max
    //   .test(
    //     "fileType",
    //     "Unsupported file format",
    //     (value) => value && ["image/jpeg", "image/png"].includes(value.type)
    //   ), // Allow JPEG/PNG
  });

  const handleFileUpload = async (file, type) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      setBtnDisabled(true);
      const response = await axios.post(`${BASE_URL}/file/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        if (type === "signature") {
          setSignatureUrl(response.data.data); // Set signature URL after successful upload
          toast.success("photo uploaded successfully");
        } else if (type === "photo") {
          setPhotoUrl(response.data.data); // Set signature URL after successful upload
          toast.success("photo uploaded successfully");
        } else {
          toast.success("Photo uploaded successfully");
          // Handle photo URL if needed
        }
      }
    } catch (error) {
      if (error.response.data.status === 409) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          "An error occurred while submitting the form. Please try again."
        );
      }
      setBtnDisabled(false)
    } finally {
      setBtnDisabled(false);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    setLoading1(true);

    const payload = {
      ...values,
      photo: photoUrl,
      signatureOfCustomer: signatureUrl,
    };

    try {
      const response = await axios.post(`${BASE_URL}/form/kyc`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setShowVerifyOtp(true);
        setSessionId(response.data.data.otpSessionId);
        setNewMobileNumber(values.mobileNumber);
      } else {
        toast.error("Failed to submit the form, please try again.");
      }
    } catch (error) {
      if (error.response.data.status === 409) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          "An error occurred while submitting the form. Please try again."
        );
      }
    } finally {
      setLoading1(false);
    }
  };

  const onSubmitOtp = async (otp) => {
    setLoading1(true);

    const payload = {
      otpSessionId: sessionId,
      otp: otp,
      mobileNumber: newMobileNumber,
    };
    try {
      const response = await axios.post(
        `${BASE_URL}/form/kyc/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setShowVerifyOtp(false);
        if (formikRef.current) {
          formikRef.current.resetForm();
        }
        if (fileInput1Ref.current) {
          fileInput1Ref.current.value = "";
        }
        if (fileInput2Ref.current) {
          fileInput2Ref.current.value = "";
        }
        setSignaturePreview(null);
        setPhotoUrl(null);
        setphotoPreview(null);
        toast.success("Your request has been submitted successfully.");
      } else {
        toast.error("Failed to submit the form, please try again.");
      }
    } catch (err) {
      toast.error("An error occurred while submitting your request.");
      console.error(err);
    } finally {
      setLoading1(false);
    }
  };

  return (
    <section className="contact-four py-40 rpy-100" id="KYC">
      <div className="section-title text-center mb-35">
        <h1>KYC FORM</h1>
        <h2>M/S. RAJESWARI MAPOSI INDANE AGENCY</h2>
        <h4>CUSTOMER VERIFICATION SHEET FOR SUBSIDISED LPG</h4>
      </div>
      <Formik
        innerRef={formikRef}
        initialValues={{
          // consumerNumber: "",
          nameOfConsumer: "",
          firstName: "",
          // middleName: "",
          lastName: "",
          dateOfBirth: "",
          // nameOfSpouse: "",
          address: "",
          roadName: "",
          landMark: "",
          city: "CHENNAI",
          pinCode: "",
          // rationCardNumber: "",
          // telephoneNumber: "",
          mobileNumber: "",
          // panNumber: "",
          // passportNumber: "",
          // drivingLicenseNumber: "",
          aadhaar: "",
          // votersIdNumber: "",
          photo: "",
          // signatureOfCustomer: "",
        }}
        validationSchema={validationSchema}
        // validate={(values) => {
        //   console.log('values',values)
        //   const errors = validationSchema.validateSync(values, { abortEarly: false });
        //   console.log("Validation Errors:", errors);
        //   // return errors;
        // }}
        onSubmit={(values) => {
          handleSubmit(values, { resetForm: () => {} });
        }}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className="formspace">
            {/* Name and other fields */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="consumerNumber" className="form-label">
                  Consumer Number
                </label>
                <Field
                  type="text"
                  name="consumerNumber"
                  className="form-control"
                />
                <ErrorMessage
                  name="customerNumber"
                  component="div"
                  className="error-message text-danger"
                />
              </div>
              {/* Other form fields here */}

              <div className="col-md-4">
                <label htmlFor="nameOfConsumer" className="form-label">
                  Name of Consumer<sup>*</sup>
                </label>
                <Field
                  type="text"
                  name="nameOfConsumer"
                  className="form-control"
                />
                <ErrorMessage
                  name="nameOfConsumer"
                  component="div"
                  className="text-danger"
                />
              </div>
            </div>

            {/* Row 2: Middle Name, Date of Birth, Spouse Name */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="firstName" className="form-label">
                  First Name<sup>*</sup>
                </label>
                <Field type="text" name="firstName" className="form-control" />
                <ErrorMessage
                  name="firstName"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="middleName" className="form-label">
                  Middle Name
                </label>
                <Field type="text" name="middleName" className="form-control" />
              </div>
              <div className="col-md-4">
                <label htmlFor="lastName" className="form-label">
                  Last Name<sup>*</sup>
                </label>
                <Field type="text" name="lastName" className="form-control" />
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="text-danger"
                />
              </div>
            </div>

            {/* Row 3: Family Size, Address, House Number */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="dateOfBirth" className="form-label">
                  Date of Birth<sup>*</sup>
                </label>
                <Field
                  type="date"
                  name="dateOfBirth"
                  className="form-control"
                />
                <ErrorMessage
                  name="dateOfBirth"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="nameOfSpouse" className="form-label">
                  Name of Spouse
                </label>
                <Field
                  type="text"
                  name="nameOfSpouse"
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="address" className="form-label">
                  Address<sup>*</sup>
                </label>
                <Field type="text" name="address" className="form-control" />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="text-danger"
                />
              </div>
            </div>

            {/* Row 5: Landmark, City, Postal Code */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="roadName" className="form-label">
                  Road Name<sup>*</sup>
                </label>
                <Field type="text" name="roadName" className="form-control" />
                <ErrorMessage
                  name="roadName"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="landMark" className="form-label">
                  Landmark<sup>*</sup>
                </label>
                <Field type="text" name="landMark" className="form-control" />
                <ErrorMessage
                  name="landMark"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="city" className="form-label">
                  City<sup>*</sup>
                </label>
                <Field
                  type="text"
                  name="city"
                  value="Chennai"
                  className="form-control"
                />
                <ErrorMessage
                  name="city"
                  component="div"
                  className="text-danger"
                />
              </div>
            </div>

            {/* Row 6: Ration Card Number, Telephone Number, Mobile Number */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="pinCode" className="form-label">
                  Postal Code<sup>*</sup>
                </label>
                <Field type="text" name="pinCode" className="form-control" />
                <ErrorMessage
                  name="pinCode"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="rationCardNumber" className="form-label">
                  Ration Card Number
                </label>
                <Field
                  type="text"
                  name="rationCardNumber"
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="telephoneNumber" className="form-label">
                  Telephone Number
                </label>
                <Field
                  type="text"
                  name="telephoneNumber"
                  className="form-control"
                />
              </div>
            </div>

            {/* Row 7: PAN, Passport, Driving License */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="mobileNumber" className="form-label">
                  Mobile Number<sup>*</sup>
                </label>
                <Field
                  type="text"
                  name="mobileNumber"
                  className="form-control"
                />
                <ErrorMessage
                  name="mobileNumber"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="panNumber" className="form-label">
                  PAN Number
                </label>
                <Field type="text" name="panNumber" className="form-control" />
              </div>
              <div className="col-md-4">
                <label htmlFor="passportNumber" className="form-label">
                  Passport Number
                </label>
                <Field
                  type="text"
                  name="passportNumber"
                  className="form-control"
                />
              </div>
            </div>

            {/* Row 8: Aadhaar, Voter's ID, Signature */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="drivingLicenseNumber" className="form-label">
                  Driving License Number
                </label>
                <Field
                  type="text"
                  name="drivingLicenseNumber"
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="aadhaar" className="form-label">
                  Aadhaar Number<sup>*</sup>
                </label>
                <Field type="text" name="aadhaar" className="form-control" />
                <ErrorMessage
                  name="aadhaar"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="votersIdNumber" className="form-label">
                  Voter Id
                </label>
                <Field
                  type="text"
                  name="votersIdNumber"
                  className="form-control"
                />
              </div>
            </div>

            {/* Photo */}

            <div className="row mb-3">
              <div className="col-md-4">
                <label htmlFor="photo" className="form-label">
                  Profile Image<sup>*</sup>
                </label>
                <input
                  type="file"
                  name="photo"
                  ref={fileInput2Ref}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFieldValue("photo", file);
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setphotoPreview(reader.result);
                      };
                      reader.readAsDataURL(file);
                      handleFileUpload(file, "photo"); // Upload the file
                    }
                  }}
                  required
                />
                <ErrorMessage
                  name="photo"
                  component="div"
                  className="text-danger"
                />
                {photoPreview && (
                  <div>
                    <img
                      className="photo-preview"
                      src={photoPreview}
                      alt="photo Preview"
                    />
                  </div>
                )}
              </div>

              {/* File Upload for Signature */}
              <div className="col-md-4">
                <label htmlFor="signatureOfCustomer" className="form-label">
                  Signature
                </label>
                <input
                  type="file"
                  name="signatureOfCustomer"
                  ref={fileInput1Ref}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFieldValue("signatureOfCustomer", file);
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setSignaturePreview(reader.result);
                      };
                      reader.readAsDataURL(file);
                      handleFileUpload(file, "signature");
                    }
                  }}
                  
                />
                <ErrorMessage
                  name="signatureOfCustomer"
                  component="div"
                  className="text-danger"
                />
                {signaturePreview && (
                  <div>
                    <img
                      className="signature-preview"
                      src={signaturePreview}
                      alt="Signature Preview"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="submitBtn"
              disabled={isSubmitting || loading1 || isBtnDisabled}
            >
              {loading1 ? "Submitting..." : "Submit"}
            </button>
          </Form>
        )}
      </Formik>

      {/* OTP Verification Modal */}
      <VerifyOtp
        modalIsOpen={showOtpPopup}
        closeModal={() => setShowVerifyOtp(false)}
        onConfirmOtp={onSubmitOtp}
      />
    </section>
  );
}

export default FormOne;
